export const CREATE_CHAT='CREATE_CHAT'
export const OPEN_SESSION_MODAL = 'OPEN_SESSION_MODAL'
export const DISPLAY_CHAT_INPUT = 'DISPLAY_CHAT_INPUT' 